import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Eye, LogOut } from 'lucide-react';
import { useUser } from '../contexts/UserContext';

/**
 * Sticky banner shown at the top of the viewport when a REDEX admin is
 * impersonating a sandbox tenant user. Provides context and a one-click
 * exit back to the admin session.
 */
export function ImpersonationBanner() {
  const { impersonating, exitImpersonation } = useUser();
  const navigate = useNavigate();

  if (!impersonating) return null;

  const handleExit = () => {
    exitImpersonation();
    navigate('/admin/sandbox/tenants');
  };

  return (
    <div className="fixed top-0 left-0 right-0 z-[9999] bg-amber-500 text-white px-4 py-2 flex items-center justify-between gap-4 shadow-lg">
      <div className="flex items-center gap-2 text-sm font-medium min-w-0">
        <Eye className="w-4 h-4 flex-shrink-0" />
        <span className="truncate">
          Viewing as <strong>{impersonating.targetEmail}</strong>
          {impersonating.sandboxTenantId && (
            <span className="font-normal opacity-80"> — sandbox: <code className="font-mono">{impersonating.sandboxTenantId}</code></span>
          )}
        </span>
      </div>
      <button
        onClick={handleExit}
        className="flex items-center gap-1.5 px-3 py-1 bg-white/20 hover:bg-white/30 rounded text-xs font-semibold whitespace-nowrap transition-colors flex-shrink-0"
      >
        <LogOut className="w-3.5 h-3.5" />
        Exit Impersonation
      </button>
    </div>
  );
}
